module.exports = __webpack_public_path__ + "img/slide-2.43020e7a.png";